import { useSearchParams } from 'react-router-dom'

import { RedirectToMobile } from '@cash-web/shared-feature-redirect-to-mobile'

export const JourneyNotFound = () => {
  const [searchParams] = useSearchParams()
  const clientRouteUrl = searchParams.get('clientRouteUrl') ?? undefined
  const deepLinkPath = searchParams.get('deepLinkPath') as `/${string}` | null

  return <RedirectToMobile clientRouteUrl={clientRouteUrl} deepLinkPath={deepLinkPath ?? undefined} />
}
